import React, {Component} from 'react';
import {Container, Jumbotron, Alert, Row, Col} from 'reactstrap';
import axios from 'axios';
import {withRouter} from 'react-router-dom'

import AssetInformation from '../../components/AssetInformation/AssetInformation';
import Pagination from '../../components/common/Pagination/Pagination';
import Spinner from '../../components/common/Spinner/Spinner';
import AssetDetail from './AssetDetail/AssetDetail';
import {getManufacturer, getTidLookup, getAlternativeProducts} from '../../Api';
import {CPU, PAGINATION_VALUE_50, PAGINATION_VALUE_100, PAGINATION_VALUE_200, PAGINATION_VALUE_500} from '../../Constants';

class ViewAsset extends Component {
    constructor(props) {
        super(props);
        this.state = {
            manufacturer: "",
            label: "",
            alternativeProducts: [],
            details: {},
            intialLoading: true,
            componentLoading: false,
            category: "",
            size: PAGINATION_VALUE_50,
            totalPageSize: 0,
            pageNumber: 1,
            totalResultCount: 0,
            from: 0,
            showPagination: false,
            tid: "",
            errorLoadingAssetInfo: false,
            isLoading: false,
            activeTab: '1',
            nextDisabled: false,
            prevDisabled: true,
            showAlternativeTab: true,
        };
    }


    componentWillMount() {
        let tid = this.props.match.params.tid;
        this.setState({tid})
        this.reloadAsset(tid);
    }

    componentWillReceiveProps(nextProps) {
        let tid = nextProps.match.params.tid;
        this.setState({ activeTab: '1', intialLoading: true, showPagination: false, pageNumber : 1});
        this.reloadAsset(tid);
    }

    showPagination = (showPagination) => {
        this.setState({showPagination: showPagination});
    }

    limitChangeAction = (size) => {
        this.setState({size, from: 0, isLoading: true, pageNumber: 1});
        this.setPaginationControlsState(1);
        this.reloadAlternativeProducts(0, size);
    }

    nextAction = () => {
        let from = this.state.from + this.state.size;
        let pageNumber = this.state.pageNumber + 1;
        this.setState({from, isLoading: true, pageNumber: pageNumber});
        this.setPaginationControlsState(pageNumber);
        this.reloadAlternativeProducts(from, this.state.size);
    }

    previousAction = () => {
        let from = this.state.from - this.state.size;
        let pageNumber = this.state.pageNumber - 1;
        this.setState({from, isLoading: true, pageNumber: pageNumber});
        this.setPaginationControlsState(pageNumber);
        this.reloadAlternativeProducts(from, this.state.size);
    }

    setPaginationControlsState = (pageNumber) => {
        this.setState({
            prevDisabled: pageNumber <= 1,
            nextDisabled: !(pageNumber < this.state.totalPageSize)
        })
    }

    pageNumberChangeAction = (e) => {
        if (e.keyCode === 13) {
            if (e.target.value < 1 || e.target.value > this.state.totalPageSize) {
                let from = this.state.size * 1;
                this.setState({pageNumber: 1, isLoading: true, from});
                this.reloadAlternativeProducts(from, this.state.size, 1);
            } else {
                let from = this.state.size * e.target.value - this.state.size;
                let pageNumber = parseInt(e.target.value, 10);
                this.setState({
                    from,
                    isLoading: true,
                    pageNumber: pageNumber
                });
                this.setPaginationControlsState(pageNumber);
                this.reloadAlternativeProducts(from, this.state.size);
            }
        }
    }

    calculatePages = (total, size) => {
        return Math.ceil(total / size);
    }

    reloadAlternativeProducts = (from, size) => {
        var self = this;
        self.setState({from, size, activeTab: '2'});

        getAlternativeProducts(from, size, self.state.category).then(function (alternativeProducts) {
            self.setState({
                alternativeProducts: self.removeSelfFromArray(alternativeProducts.data.results, self.state.tid),
                totalPageSize: self.calculatePages(alternativeProducts.data.total_results, self.state.size),
                isLoading: false
            });
        })
    }

    reloadAsset = (tid) => {
        var self = this;
        getTidLookup(tid).then(function (response) {
            let results = response.data.result;
            let label = results.label;
            let category = results.attributes.category;
            let version = results.attributes.version || results.attributes.model;
            self.setState({details: results.attributes, label, category, version})
            if (label !== CPU) {
                return axios.all([
                    getManufacturer(tid, label),
                    getAlternativeProducts(self.state.from, self.state.size, category)
                ]).then(axios.spread(function (manufacturer, alternativeProducts) {
                    self.setState({
                        manufacturer: manufacturer.data.results[0].m.attributes.title,
                        alternativeProducts: self.removeSelfFromArray(alternativeProducts.data.results, tid),
                        intialLoading: false,
                        totalPageSize: self.calculatePages(alternativeProducts.data.total_results, self.state.size)
                    })
                }))
            } else {
                self.setState({showAlternativeTab: false});
                return getManufacturer(tid,label).then(function (manufacturer) {
                    self.setState({
                        manufacturer: manufacturer.data.results[0].m.attributes.title,
                        intialLoading: false,
                    })
                });
            }
        })
        .catch(function (error) {
            self.setState({errorLoadingAssetInfo: true});
        });
    }

    removeSelfFromArray = (alternativeProducts, tid) => {
       return alternativeProducts.filter(p => p.technopedia_id !== tid);
    }


    render() {
        if (this.state.isLoading) {
            return (
                <Container>
                    <Spinner/>
                </Container>
            );
        }

        const paginatedControl = this.state.showPagination
            ? (
                <div className="sub-footer p-5">
                    <Pagination
                        pageNumber={this.state.pageNumber}
                        showPaginationControl={false}
                        pageNumberChangeAction={this.pageNumberChangeAction}
                        previousDisabled={this.state.prevDisabled}
                        nextDisabled={this.state.nextDisabled}
                        pageCount={this.state.totalPageSize}
                        values={[PAGINATION_VALUE_50, PAGINATION_VALUE_100, PAGINATION_VALUE_200, PAGINATION_VALUE_500]}
                        nextAction={this.nextAction}
                        previousAction={this.previousAction}
                        limit={this.state.size}
                        limitChangeAction={this.limitChangeAction}/>
                </div>
            )
            : null;

        if (this.state.errorLoadingAssetInfo) {
            return (
                <Container className="my-2">
                    <Row>
                        <Col>
                            <Alert color="danger text-center">Unable to find asset with a technopedia id of
                                <strong> {this.state.tid}</strong>.</Alert>
                        </Col>
                    </Row>
                </Container>
            );
        }

        if (this.state.intialLoading) {
            return <div>
                    <Spinner/>
                </div>
        }

        return (
            <div>
                <Jumbotron fluid role="banner">
                    <Container>
                        <AssetInformation
                            title={this.state.details.title}
                            label={this.state.label}
                            manufacturer={this.state.manufacturer}
                            version={this.state.version}/>
                    </Container>
                </Jumbotron>
                <Container role="article">
                    <AssetDetail
                        componentLoading={this.state.componentLoading}
                        changePaginationState={this.showPagination}
                        activeTab={this.state.activeTab}
                        showAlternative={this.state.showAlternativeTab}
                        {...this.state}/>
                </Container>
                {paginatedControl}
            </div>
        );
    }
}

export default withRouter(ViewAsset);



// WEBPACK FOOTER //
// ./src/containers/ViewAsset/ViewAsset.js